import { render, staticRenderFns } from "./MyIntroduce1.vue?vue&type=template&id=72eea7ca&scoped=true"
import script from "./MyIntroduce1.vue?vue&type=script&lang=js"
export * from "./MyIntroduce1.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce1.vue?vue&type=style&index=0&id=72eea7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eea7ca",
  null
  
)

export default component.exports